var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input-number',{attrs:{"min":_vm.min,"step":_vm.step},on:{"input":_vm.setVal},model:{value:(_vm.MaxActionScore),callback:function ($$v) {_vm.MaxActionScore=$$v},expression:"MaxActionScore"}})
}
var staticRenderFns = []

export { render, staticRenderFns }